/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC } from "react";
import { NumberFormatValues, NumericFormat } from "react-number-format";
import {
    OutlinedInput,
    InputAdornment,
    makeStyles,
    createStyles,
    IconButton,
} from "@material-ui/core";
import { TextFieldProps } from "@material-ui/core/TextField";
import { Colors } from "../../styles";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";

type Props = TextFieldProps & {
    value?: number;
    onValueChange: (values: NumberFormatValues) => void;
    allowNegative?: boolean;
};

const useStepperStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-evenly",
        width: 198,
        paddingLeft: 0,
        paddingRight: 0,
    },
});

const useStyles = makeStyles(() =>
    createStyles({
        number: {
            width: 66,
            height: 54,
            borderRadius: 0,
            paddingUp: 10,
            paddingDown: 10,
        },
        buttonLeft: {
            width: 50,
            height: 50,
            padding: 0,
            marginLeft: 2,
        },
        buttonRight: {
            width: 50,
            height: 50,
            padding: 0,
            marginRight: 2,
        },
        adornmentRoot: {
            display: "inline-table",
        },
        adornmentEnd: {
            marginRight: 0,
            width: 30.87,
            height: 30.87,
            color: Colors.anthracite,
        },
        adornmentStart: {
            width: 18,
            height: 3,
            backgroundColor: Colors.anthracite,
            Color: Colors.anthracite,
            marginLeft: 0,
        },
    }),
);

const useOutlinedInputStyles = makeStyles(() => ({
    root: {
        marginTop: 7,
        borderRadius: 28,
        height: 56,
        background: Colors.white,

        fontSize: 22,
        fontWeight: 300,
        fontStretch: "normal",
        fontStyle: "normal",
        fontFamily: "innogyWEB",
        lineHeight: 1.27,
        letterSpacing: "normal",
        color: Colors.anthracite,

        "& $notchedOutline": {
            borderColor: Colors.anthracite25,
            borderWidth: "1px",
        },
        "&:hover $notchedOutline": {
            borderColor: Colors.mellowYellow,
            borderWidth: "1px",
        },
        "&$focused $notchedOutline": {
            borderColor: Colors.blueBright,
            borderWidth: "1px",
        },
        "&$focused": {
            //backgroundColor: Colors.eggshell,
        },
    },
    focused: {},
    notchedOutline: {},

    input: {
        padding: 20,
    },
}));

export const Stepper: FC<Props> = (props: Props) => {
    const classes = useStyles();
    const stepperClasses = useStepperStyles();
    const outlinedInputClasses = useOutlinedInputStyles();
    const handleAdd = (): void => {
        const value = (props.value || 0) + 1;
        props.onValueChange({
            floatValue: value,
            formattedValue: value.toString(),
            value: value.toString(),
        });
    };
    const handleSubstract = (): void => {
        const value = (props.value || 0) - 1;
        if (value === 0) return;
        props.onValueChange({
            floatValue: value,
            formattedValue: value.toString(),
            value: value.toString(),
        });
    };

    return (
        <OutlinedInput
            className={stepperClasses.root}
            classes={outlinedInputClasses}
            labelWidth={0}
            inputComponent={NumericFormat as any}
            inputProps={
                {
                    style: {
                        textAlign: "center",
                        fontSize: 25,
                        fontWeight: 500,
                        height: "100%",
                        fontFamily: "innogyWEB",
                        fontStretch: "normal",
                        fontStyle: "normal",
                        lineHeight: "normal",
                        letterSpacing: "normal",
                        color: Colors.anthracite,
                        backgroundColor: Colors.anthracite5,
                        padding: 0,
                    },
                    thousandSeparator: ".",
                    decimalSeparator: ",",
                    decimalScale: 0,
                    ...props,
                } as any
            }
            startAdornment={
                <InputAdornment
                    className={classes.adornmentRoot}
                    position="start"
                    style={{ marginRight: 9, marginLeft: 5 }}
                >
                    <IconButton
                        className={classes.buttonLeft}
                        aria-label="toggle password visibility"
                        onClick={handleSubstract}
                    >
                        {<RemoveIcon classes={{ root: classes.adornmentStart }} />}
                    </IconButton>
                </InputAdornment>
            }
            endAdornment={
                <InputAdornment
                    className={classes.adornmentRoot}
                    position="end"
                    style={{ marginLeft: 9, marginRight: 5 }}
                >
                    <IconButton
                        className={classes.buttonRight}
                        aria-label="toggle password visibility"
                        onClick={handleAdd}
                    >
                        {<AddIcon classes={{ root: classes.adornmentEnd }} />}
                    </IconButton>
                </InputAdornment>
            }
        />
    );
};
